import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const createLink = () => {
  return new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    credentials: 'include',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
};

const client = new ApolloClient({
  link: createLink(),
  cache: new InMemoryCache(),
});

export default client;
